import { atom } from "jotai";

export const anioAtom = atom(new Date().getFullYear());
export const filtroEstadoAtom = atom(undefined);
export const loadingImportarAtom = atom(false);
export const loadingTablaAtom = atom(false);
export const recargarTablaAtom = atom(0);
export const programacionVacacionesAtom = atom([]);
export const paginaActualAtom = atom(1);
export const tamanioPaginadoAtom = atom(10);
export const totalRegistrosAtom = atom(0);
export const selectedRowKeysAtom = atom([]);
